// extracted by mini-css-extract-plugin
export default {"link":"LinkDark_link__0qjlU","disabled":"LinkDark_disabled__dAlUM"};